// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv > svg[data-v-80847238] {\n  -webkit-transform: translateY(-2px);\n          transform: translateY(-2px);\n}\n", ""]);
// Exports
module.exports = exports;
